import { useMemo } from 'react';

export const useNavConfig = () => {
  return useMemo(
    () => [
      {
        title: 'Price',
        path: '/price.html',
      },
      {
        title: 'Contact',
        path: '/contact.html',
      },
    ],
    []
  );
};
